import { FilterMetadata, FilterOperators, FilterTypes } from "./types";

// // // //

/**
 * The immutable ID of the root filter being edited in FilterEditor
 */
export const ROOT_FILTER_ID = "ROOT";

export const FILTER_OPERATOR_TO_LABEL: Record<FilterOperators, string> = {
    [FilterOperators.And]: "And",
    [FilterOperators.Or]: "Or",
    [FilterOperators.Equals]: "Equals",
    [FilterOperators.NotEquals]: "Not Equals",
    [FilterOperators.Like]: "Like",
    [FilterOperators.NotLike]: "Not Like",
    [FilterOperators.ILike]: "Like (case insensitive)",
    [FilterOperators.EndsWith]: "Ends With",
    [FilterOperators.StartsWith]: "Starts With",
    [FilterOperators.In]: "In",
    [FilterOperators.NotIn]: "Not In",
    [FilterOperators.GreaterThan]: "Greater Than",
    [FilterOperators.LessThan]: "Less Than",
    [FilterOperators.GreaterThanOrEqual]: "Greater Than Or Equal",
    [FilterOperators.LessThanOrEqual]: "Less Than Or Equal",
    [FilterOperators.Includes]: "Includes",
    [FilterOperators.NotIncludes]: "Does Not Include",
    // // // //
    [FilterOperators.Before]: "Before",
    [FilterOperators.OnOrBefore]: "On or Before",
    [FilterOperators.After]: "After",
    [FilterOperators.OnOrAfter]: "On or After",
    [FilterOperators.IsNull]: "Is Not Set",
    [FilterOperators.IsNotNull]: "Is Set",
};

// NOTE - all icons are located in public/images/operator-icons/*.svg
export const FILTER_OPERATOR_TO_ICON: Record<FilterOperators, string> = {
    [FilterOperators.And]: "",
    [FilterOperators.Or]: "",
    [FilterOperators.Equals]: "equals.svg",
    [FilterOperators.NotEquals]: "not-equals.svg",
    [FilterOperators.Like]: "like.svg",
    [FilterOperators.NotLike]: "not-like.svg",
    [FilterOperators.ILike]: "ilike.svg",
    [FilterOperators.EndsWith]: "ends-with.svg",
    [FilterOperators.StartsWith]: "starts-with.svg",
    [FilterOperators.In]: "in.svg",
    [FilterOperators.NotIn]: "not-in.svg",
    [FilterOperators.GreaterThan]: "greater-than.svg",
    [FilterOperators.LessThan]: "less-than.svg",
    [FilterOperators.GreaterThanOrEqual]: "greater-than-or-equal.svg",
    [FilterOperators.LessThanOrEqual]: "less-than-or-equal.svg",
    [FilterOperators.Includes]: "includes.svg",
    [FilterOperators.NotIncludes]: "not-includes.svg",
    [FilterOperators.Before]: "before.svg",
    [FilterOperators.OnOrBefore]: "on-or-before.svg",
    [FilterOperators.After]: "after.svg",
    [FilterOperators.OnOrAfter]: "on-or-after.svg",
    [FilterOperators.IsNull]: "is-set.svg",
    [FilterOperators.IsNotNull]: "is-not-set.svg",
};

/**
 * SEARCH_FILTER_METADATA
 * FilterMetadata for generalized search feature
 * Must be configured for each API endpoint
 */
export const SEARCH_FILTER_METADATA: FilterMetadata = {
    type: FilterTypes.Search,
    field: "search",
    content: {
        label: "Search",
        description: "Text search across multiple fields",
    },
    defaultOperator: FilterOperators.Like,
    displayInline: true,
    defaultValue: "",
    allowedOperators: [FilterOperators.Like, FilterOperators.NotLike],
};
